import React, { createContext, useState, useEffect, useCallback } from 'react'; // <-- THE FIX IS HERE
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import apiClient from '../api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('jwt_token'));
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true); 
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    try {
      if (token) {
        const decodedUser = jwtDecode(token);
        setUser(decodedUser.user);
      }
    } catch (e) {
      localStorage.removeItem('jwt_token');
      setToken(null);
      setUser(null);
    } finally {
      // No matter what, we are done loading after the initial check
      setIsLoading(false);
    }
  }, [token]);

  const hasPermission = useCallback((permission) => {
    if (!user || !user.permissions) {
      return false;
    }
    return user.permissions.includes(permission);
  }, [user]);

  const login = async (email, password) => {
    try {
      setError('');
      const response = await apiClient.post('/api/auth/login', { email, password });
      const { token: newToken } = response.data;
      localStorage.setItem('jwt_token', newToken);
      setToken(newToken);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.msg || 'Invalid credentials. Please try again.');
      console.error(err);
    }
  };

  const logout = () => {
    localStorage.removeItem('jwt_token');
    setToken(null);
    setUser(null);
    navigate('/login');
  };
  
  // While checking the token, show a loading screen instead of the app
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Loading Application...</p>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ token, user, login, logout, error, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;